module.exports = __webpack_public_path__ + "img/works_kuraray_miniapp_4@1x.17f619e8.png";